import { FaceDetector, FilesetResolver } from "@mediapipe/tasks-vision";

// 全ブラウザ(iPhone/Android含む)で動くWASM顔検出。シングルトンで初期化。
let _detPromise = null;
let _lastTs = 0;

export function getFaceDetector() {
  if (!_detPromise) {
    _detPromise = (async () => {
      const vision = await FilesetResolver.forVisionTasks(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@1.0.1/wasm"
      );
      return await FaceDetector.createFromOptions(vision, {
        baseOptions: {
          modelAssetPath:
            "https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite",
          delegate: "CPU",
        },
        runningMode: "VIDEO",
        minDetectionConfidence: 0.5,
      });
    })().catch((e) => {
      console.error("MediaPipe FaceDetector init failed", e);
      return null;
    });
  }
  return _detPromise;
}

// video から最も大きい顔の矩形(動画ピクセル座標)を返す。未検出/未対応は null。
export function detectFaceBox(detector, video) {
  if (!detector || !video || !video.videoWidth) return null;
  try {
    let ts = performance.now();
    if (ts <= _lastTs) ts = _lastTs + 1;
    _lastTs = ts;
    const res = detector.detectForVideo(video, ts);
    const dets = res && res.detections ? res.detections : [];
    if (!dets.length) return null;
    let best = dets[0];
    for (const d of dets) {
      if ((d.boundingBox?.width || 0) * (d.boundingBox?.height || 0) >
          (best.boundingBox?.width || 0) * (best.boundingBox?.height || 0)) best = d;
    }
    const bb = best.boundingBox;
    if (!bb) return null;
    return { x: bb.originX, y: bb.originY, width: bb.width, height: bb.height };
  } catch (e) {
    return null;
  }
}
